var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "form-container" }, [
    _c(
      "div",
      { class: ["form"] },
      [
        _c(
          _setup.ValidationObserver,
          {
            ref: "form",
            staticClass: "login-form",
            attrs: { tag: "form" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _setup.login.apply(null, arguments)
              },
            },
          },
          [
            _c(_setup.TextFieldComponent, {
              staticClass: "input-container",
              attrs: {
                validationRules: "required|email",
                prependIcon: _setup.icons.mail,
                placeholder: _setup.text.email,
                id: "email",
              },
              model: {
                value: _setup.credentials.email,
                callback: function ($$v) {
                  _vm.$set(
                    _setup.credentials,
                    "email",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "credentials.email",
              },
            }),
            _c(_setup.TextFieldComponent, {
              staticClass: "input-container",
              attrs: {
                validationRules: "required",
                id: "password",
                prependIcon: _setup.icons.lock,
                appendIcon: _setup.icons.visible,
                placeholder: _setup.text.password,
                type: "password",
              },
              model: {
                value: _setup.credentials.password,
                callback: function ($$v) {
                  _vm.$set(
                    _setup.credentials,
                    "password",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "credentials.password",
              },
            }),
            _setup.authStore.error
              ? _c(_setup.StaticAlertComponent, {
                  staticClass: "static-alert",
                  attrs: { alert: _setup.alert },
                })
              : _vm._e(),
            _c(_setup.RememberCheckboxComponent),
            _c(
              "button",
              {
                staticClass: "login-button",
                attrs: { type: "submit", name: "submit" },
              },
              [_vm._v("Acceder")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }